import React, {useEffect, useState} from "react";
import slide1 from "../../../assets/slides/GALCO_INSU_LANDSCAPE_1000X200PX.jpg";
import slide2 from "../../../assets/slides/GALCO_LTD_LANDSCAPE_1000X200PX.jpg";
import slide3 from "../../../assets/slides/GSM_BEVERAGE_Landscape_1000X200PX.jpg";
import slide4 from "../../../assets/slides/GSM_BUILDING_LANDSCAPE_1000X200PX.jpg";
import slide5 from "../../../assets/slides/GSM_Home_Landscape_1000x200px.jpg";
import slide6 from "../../../assets/slides/GSM_Retail_1000x200px.jpg";
import slide7 from "../../../assets/slides/GSM-ENERGIES_LANDSCAPE_1000X200PX.jpg";
import slide8 from "../../../assets/slides/GSM-TZ_Products_1000X200PX.jpg";
// import {getGSMAdvert} from "../services/gsm_advert.mjs";

const slides = [slide1, slide2, slide3, slide4, slide5, slide6, slide7, slide8];

export function BeverageBanner() {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        // getGSMAdvert().then(value => { /* remote images */ }).catch(() => {});
        const timer = setInterval(() => {
            setCurrent(prev => (prev + 1) % slides.length);
        }, 3000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div data-testid="beverage-banner" style={{position: 'relative', width: '100%', overflow: 'hidden'}}>
            <div
                data-testid="beverage-banner-track"
                style={{
                    display: 'flex',
                    transition: 'transform 0.6s ease-in-out',
                    transform: `translateX(-${current * (100 / slides.length)}%)`,
                    width: `${slides.length * 100}%`,
                }}
            >
                {slides.map((src, index) => (
                    <div
                        key={index}
                        style={{
                            width: `${100 / slides.length}%`,
                            flexShrink: 0,
                        }}
                    >
                        <img
                            src={src}
                            alt={`slide-${index}`}
                            data-testid={`beverage-slide-${index}`}
                            style={{width: '100%', height: 'auto', display: 'block'}}
                        />
                    </div>
                ))}
            </div>
            <div
                data-testid="beverage-banner-dots"
                style={{
                    position: 'absolute',
                    bottom: 10,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 8,
                }}>
                {slides.map((_, index) => (
                    <div
                        key={index}
                        data-testid={`beverage-dot-${index}`}
                        onClick={() => setCurrent(index)}
                        style={{
                            width: current === index ? 20 : 8,
                            height: 8,
                            borderRadius: 4,
                            backgroundColor: current === index ? '#fff' : 'rgba(255,255,255,0.5)',
                            cursor: 'pointer',
                            transition: 'width 0.3s ease',
                        }}
                    />
                ))}
            </div>
        </div>
    );
}
